import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';
import {nomenclature} from './nomenclature.reducer';
import {insertTramite} from './homologation.reducer';
import {forgotPassword} from './forgotPassword.reducer';
import {changePassword} from './changePassword.reducer'
import {insertstatitics} from './statistics.reducer'

const rootReducer = combineReducers({
  authentication,
  registration,
  users,
  alert,
  nomenclature,
  insertTramite,
  forgotPassword,
  changePassword,
  insertstatitics
});

export default rootReducer;